import { useForm } from 'react-hook-form'
import { Dropdown } from 'components/common'
import { useQuery } from 'hooks'
import { filterEmptyValues } from 'utils/helpers'

export const FILTER_FIELD_AGGREGATOR = 'aggregatorFilters'

const booleanFilterOptions = [
  { label: '--- NONE ---', value: 'NONE', disabled: false },
  { label: 'Yes', value: 'true', disabled: false },
  { label: 'No', value: 'false', disabled: false },
]

const AGGREGATOR_FILTER_FIELDS = [
  { key: 'isActive', label: 'Active' },
  { key: 'ftpIsEnable', label: 'FTP Status' },
  { key: 'ftpIsRunning', label: 'FTP Running' },
  { key: 'apiIsEnable', label: 'API Status' },
]

/**
 * Always-visible filter bar rendered directly above the aggregator table -
 * no separate filter page/toggle, applies immediately on change. Query-param
 * names match aggregatorFilterConfig on the backend (see
 * src/controllers/aggregator/helpers/aggregatorFilterConfig.ts).
 */
const AggregatorFilterBar = () => {
  const { getQuery, setMultipleQueries } = useQuery()
  const filters = getQuery(FILTER_FIELD_AGGREGATOR) || {}

  const { setValue } = useForm({ defaultValues: filters })

  const handleChange = (key: string, value: string | boolean | null) => {
    const nextFilters = { ...filters, [key]: value }
    if (value === 'NONE') delete nextFilters[key]

    const filteredData = filterEmptyValues(nextFilters)

    setMultipleQueries({
      [FILTER_FIELD_AGGREGATOR]:
        Object.keys(filteredData).length > 0 ? filteredData : undefined,
      page: 1,
    })
  }

  return (
    <div className="mb-4 flex flex-wrap items-end gap-4">
      {AGGREGATOR_FILTER_FIELDS.map(({ key, label }) => (
        <div key={key} className="w-full mid-md:w-48">
          <Dropdown
            label={label}
            name={key}
            options={booleanFilterOptions}
            defaultValue={filters?.[key] ?? 'NONE'}
            setValue={setValue}
            onChange={(value) => handleChange(key, value)}
          />
        </div>
      ))}
    </div>
  )
}

export default AggregatorFilterBar
